import React, {Component} from "react";
import {connect} from "react-redux";
import {saveSuperAdminPassword} from "../client/actions/apiActions";
import {toastr} from "react-redux-toastr";
import {  Redirect } from "react-router-dom";

class SuperAdminPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            password: '',
			confirmPassword: '',
			isValidForm: false,
			errorMessages: {
				password: '',
				confirmPassword: ''
			},
            timeOut: 5000,
            showCloseButton: true,
            progressBar: true,
            position: "top-right"
            
        }
    }

    showToastr = (type, title, message) => {
        const options = {
            timeOut: parseInt(this.state.timeOut),
            showCloseButton: this.state.showCloseButton,
            progressBar: this.state.progressBar,
            position: this.state.position
        };
        const toastrInstance =
            type === "info"
                ? toastr.info
                : type === "warning"
                ? toastr.warning
                : type === "error"
                    ? toastr.error
                    : toastr.success;

        toastrInstance(
            title,
            message,
            options
        );
    }

    componentDidMount() {
        
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps !== this.props) {
            this.setState({
                password: '',
                confirmPassword: '',
                isValidForm: false
            });
            let data = this.props.data;
            if (data.status == true) {
                this.showToastr("success", "Success", data.message);
            }
            if (data.status == false) {
                this.showToastr("error", "Error", data.message);
            }
        }
    }

    onChange = (entry) => {
		this.setState({
			[entry.target.name]: entry.target.value
		})

		let isValidForm = false;
		const name = entry.target.name;
		const value = entry.target.value;
		const errorMessages = this.state.errorMessages;

		if (value == "") {
			errorMessages[name] = 'This field is required.';
		}else{
			isValidForm = true;
		}
		this.setState({errorMessages, isValidForm});

	}

	saveForm = () => {
		const { password, confirmPassword } = this.state;
		const errorMessages = this.state.errorMessages;
		errorMessages.password = errorMessages.confirmPassword = '';

		this.setState({errorMessages});
		
		if (password == "") {
			errorMessages.password = 'This field is required.';
            this.showToastr("error", "Error", 'Password field is required.');
		}else if(confirmPassword == "") {
			errorMessages.confirmPassword = 'This field is required.';
            this.showToastr("error", "Error", 'Confirm Password field is required.');
		}else if(password != confirmPassword) {
			errorMessages.confirmPassword = '';
            this.showToastr("error", "Error", 'Password confirmation does not match.');
		}else {
			this.props.saveSuperAdminPassword(password, confirmPassword);
		}
		this.setState({errorMessages,isValidForm:false});

	}


    render() {
        let auth = this.props.auth;
        if(auth.user.userRole != 1){
            return (<Redirect path={`/dashboard`} />);
        }
        const { password, confirmPassword, errorMessages, isValidForm } = this.state;
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <h2>Update Super Admin Password</h2>
                        <div className="card">
                            <div className="card-body">
                                { (errorMessages.password != '' || errorMessages.confirmPassword != '') && <><div className="alert alert-danger p-4 "> All fields are required.</div></>}
                                <form noValidate autoComplete="off" onSubmit={(e) => e.preventDefault()} >

                                    <legend>Update Password</legend>
                                    
                                    <div className="form-group">
                                        <label htmlFor="password">Password <span className="text-danger">*</span></label>
                                        <input 
                                        type="password" 
                                        className="form-control"
                                        name="password" 
                                        onChange={this.onChange}
                                        id="password"
                                        placeholder="Password"
                                        value={password}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="confirmPassword">Confirm Password <span className="text-danger">*</span></label>
                                        <input 
                                        type="password" 
                                        className="form-control"
                                        name="confirmPassword" 
                                        onChange={this.onChange}
                                        id="confirmPassword"
                                        placeholder="Confirm Password"
                                        value={confirmPassword}
                                        />
                                    </div>
                                
                                    <button className="btn btn-primary" disabled={!isValidForm} onClick={this.saveForm}>Update</button>
                                </form>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    auth: state.auth.user,
    userPermissions: state.auth.user.userRole,
    data: state.pages.data,
});

export default connect(mapStateToProps, { saveSuperAdminPassword })(SuperAdminPassword);
